(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name itecAdministracio.shared.document.directive:admFormFileUploadManteniment
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module='itecAdministracio.shared.document'>
       <file name='index.html'>
        <itec-file-upload-manteniment-directive></itec-file-upload-manteniment-directive>
       </file>
     </example>
   *
   */
  angular
    .module('itecAdministracio.shared.document')
    .directive('admFormFileUploadManteniment', admFormFileUploadManteniment);

  function admFormFileUploadManteniment(Upload, $timeout, $cookies, $stateParams) {
    return {
      restrict: 'EA',
      scope: {
        chunkSize           : '@?',
        selectFilesText     : '@',
        saveFilesText       : '@',
        maxSize             : '@?',
        maxSizeExceededText : '@',
        idEntitat           : '=',
        listCategories      : '=',
        onFinishFunction    : '&?',
        urlBase             : '=',
        urlController       : '='
      },
      templateUrl: 'shared/document/adm-form-file-upload-manteniment-directive.tpl.html',
      replace: false,
      controllerAs: 'vm',
      controller: function ($scope, AdmConstant, UploadFactory, UploadFileConstants, HelperFactory) {
        var vm = this;
        vm.name = 'admFormFileUploadManteniment';
        
        vm.files      = [];
        vm.errFiles   = [];

        vm.chunkSize  = angular.isUndefined($scope.chunkSize) ? UploadFileConstants.CHUNKSIZE : $scope.chunkSize;
        vm.maxSize    = angular.isUndefined($scope.maxSize) ? UploadFileConstants.MAX_SIZE_UPLOAD_DEFAULT : $scope.maxSize;
        vm.onFinishFunction = $scope.onFinishFunction;

        vm.cleanForm      = cleanForm;
        vm.selectFiles    = selectFiles;
        vm.invalidForm    = UploadFactory.invalidForm;
        vm.uploadFiles    = uploadFiles;
        vm.pending        = UploadFactory.pending;

        /////////////////////////////////////////////////////
        //----------------- functions ---------------------//
        /////////////////////////////////////////////////////

        //quan selecciem fitxers creem els formularis
        function selectFiles() {
          angular.forEach(vm.files, function(objFile) {
            if (angular.isUndefined(objFile.fields)) {
              objFile.fields =  {
                  title : objFile.file.name.substring(0, 255),                  
                  description:'',
                  dataDocument: new Date(),
                  dataDocumentString: '',
                  newFileId: '',
                  idEntitat: $scope.idEntitat,
                  selected: true,
                  extendedForm: false
              };
            }
          });
        }

        function cleanForm() {
          vm.files = [];
          vm.errFiles = [];
        }

        function onFinishUpload(objFile, response) {
          objFile.file.result = response.data;
          objFile.fields.selected = false;
          if (UploadFactory.checkFinalUpload()) {
            vm.cleanForm();
            if (!angular.isUndefined(vm.onFinishFunction)) {
              vm.onFinishFunction();
            }
          }
        }

        function uploadFiles() {
          angular.forEach(vm.files, function(objFile, index) {   

            if (objFile.fields.selected){
              objFile.fields.newFileId = HelperFactory.uniqueMoment(index);

              var date = new Date(objFile.fields.dataDocument);
              objFile.fields.dataDocumentString = date.getTime();
              objFile.fields.idEntitat = $scope.idEntitat;

              init_app({name: 'security', version: AdmConstant.SERVER_ADMINISTRACIO_VERSION} , $cookies.get('authsecurity')).then( function(response){

                objFile.chunkSize = vm.chunkSize;
                objFile.sizeUrl = 'ok.html'+'?newFileId='+objFile.fields.newFileId+'&name='+objFile.file.name;
                objFile.baseUrl = $scope.urlBase;
                objFile.controllerUrl = $scope.urlController;
                objFile.headers = { 'authmanteniment' : response.app.auth,
                                        'x-api-version' : AdmConstant.SERVER_ADMINISTRACIO_VERSION};
                UploadFactory.uploadFile(objFile, onFinishUpload);

              });
            }

          });
        }

      },
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint 'no-unused-vars': [2, {'args': 'none'}] */
      }
    };
  }
}());